{
  "cpu": {
    "id_subcategoria": [48, 27],
    "relaciones": {
      "mother": [
        {
          "origen": "tipo",
          "destino": "cpus"
        },
        {
          "origen": ["idSubcate"],
          "destino": ["idSubcate"]
        }
      ]
    }
  },
  "fuente": {
    "id_subcategoria": [34],
    "relaciones": {
      "gab": [
        {
          "origen": ["compatible_abajo"],
          "destino": ["posicion_fuente_superior"]
        }
      ]
    }
  },
  "gab": {
    "id_subcategoria": [7],
    "relaciones": {
      "fuente": [
        {
          "origen": ["posicion_fuente_superior"],
          "destino": ["compatible_abajo"]
        }
      ],
      "mother": [
        {
          "origen": ["tipo_mother"],
          "destino": ["Factor"]
        }
      ],
      "ccpu": [
        {
          "origen": ["altura_ccpu"],
          "destino": ["altura_real"]
        },
        {
          "origen": ["cf_continuos_con_espacio_disipador"],
          "destino": ["tipo_disipacion"]
        },
        {
          "origen": ["cf_2x120mm_continuos", "cf_3x120mm_continuos"],
          "destino": ["espacios_120mm"]
        },
        {
          "origen": ["cf_2x140mm_continuos", "cf_3x140mm_continuos"],
          "destino": ["espacios_140mm"]
        }
      ],
      "coolerfan": [
        {
          "origen": ["cf_80mm", "cf_120mm", "cf_140mm", "cf_200mm"],
          "destino": ["dimensiones"]
        }
      ],
      "video": [
        {
          "origen": ["largo_maximo_vga"],
          "destino": ["largo"]
        }
      ]
    }
  },
  "mother": {
    "id_subcategoria": [49, 26],
    "relaciones": {
      "cpu": [
        {
          "origen": ["cpus"],
          "destino": ["tipo"]
        },
        {
          "origen": ["idSubcate"],
          "destino": ["idSubcate"]
        }
      ],
      "gab": [
        {
          "origen": ["Factor"],
          "destino": ["tipo_mother"]
        }
      ],
      "mem": [
        {
          "origen": ["DDR3", "DDR4", "DDR5"],
          "destino": ["tipo"]
        }
      ],
      "video": [
        {
          "origen": ["nro_pcie"],
          "destino": ["tipo"]
        }
      ],
      "hd": [
        {
          "origen": ["SATA", "m2"],
          "destino": ["tipo"]
        }
      ],
      "fuente": [
        {
          "origen": ["_24pines"],
          "destino": ["_24pines"]
        },
        {
          "origen": ["_4pines"],
          "destino": ["_4pines"]
        }
      ],
      "ccpu": [
        {
          "origen": ["cpus"],
          "destino": ["sockets"]
        }
      ]
    }
  },
  "video": {
    "id_subcategoria": [6, 62],
    "relaciones": {
      "mother": [
        {
          "origen": ["tipo"],
          "destino": ["nro_pcie"]
        }
      ],
      "fuente": [
        {
          "origen": ["_2plus", "_6pines"],
          "destino": ["pcie", "pcieplus"]
        }
      ],
      "gab": [
        {
          "origen": ["largo"],
          "destino": ["largo_maximo_vga"]
        }
      ]
    }
  },
  "hd": {
    "id_subcategoria": [81, 19],
    "relaciones": {
      "mother": [
        {
          "origen": ["tipo"],
          "destino": ["SATA", "m2"]
        }
      ]
    }
  },
  "ccpu": {
    "id_subcategoria": [36],
    "relaciones": {
      "gab": [
        {
          "origen": ["altura_real"],
          "destino": ["altura_ccpu"]
        },
        {
          "origen": ["tipo_disipacion"],
          "destino": ["cf_continuos_con_espacio_disipador"]
        },
        {
          "origen": ["espacios_120mm"],
          "destino": ["cf_2x120mm_continuos", "cf_3x120mm_continuos"]
        },
        {
          "origen": ["espacios_140mm"],
          "destino": ["cf_2x140mm_continuos", "cf_3x140mm_continuos"]
        }
      ],
      "mother": [
        {
          "origen": ["sockets"],
          "destino": ["anclaje"]
        }
      ]
    }
  },
  "mem": {
    "id_subcategoria": [15],
    "relaciones": {
      "mother": [
        {
          "origen": ["tipo"],
          "destino": ["DDR3", "DDR4", "DDR5"]
        }
      ]
    }
  },
  "coolerfan": {
    "id_subcategoria": [35],
    "relaciones": {
      "gab": [
        {
          "origen": ["dimensiones"],
          "destino": ["cf_80mm", "cf_120mm", "cf_140mm", "cf_200mm"]
        }
      ]
    }
  }
}
